import React from "react";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-5 border-top bg-light">
      <div className="container py-4">
        <div className="row gy-3 align-items-center">
          <div className="col-md-6 text-center text-md-start">
            <strong>Curso</strong>
            <p className="mb-0 text-muted small">
              Plateforme de suivi des performances en course a pied.
            </p>
          </div>

          <div className="col-md-6">
            <ul className="nav justify-content-center justify-content-md-end gap-2">
              <li className="nav-item">
                <a className="nav-link px-2 py-1 text-muted" href="/faq">
                  FAQ
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link px-2 py-1 text-muted" href="/features">
                  Fonctionnalites
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link px-2 py-1 text-muted" href="/contact">
                  Contact
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link px-2 py-1 text-muted" href="/cgu">
                  CGU
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link px-2 py-1 text-muted"
                  href="/politique-confidentialite"
                >
                  Confidentialite
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="text-center text-muted small pt-3 mt-3 border-top">
          © {year} Curso. Tous droits reserves.
        </div>
      </div>
    </footer>
  );
}
